import React from 'react';
import { Typography, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { convertToQid } from '../../utilities/stringHelper';

const StyledMenuItem = styled(MenuItem)`
  &.override-disable {
    opacity: 1;
  };
`;

type Props = {
  userId?: number;
  userCountry?: string;
}

const UserId: React.FC<Props> = ({ userId, userCountry }: Props) => (
  <StyledMenuItem
    id="Menu-QID"
    disabled
    classes={{
      disabled: 'override-disable',
    }}
  >
    <Typography variant="caption" fontWeight={600}>
      Quip -
      {' '}
      { userId && convertToQid(userId, userCountry) }
    </Typography>
  </StyledMenuItem>
);

export default UserId;
